import { useCallback, useState } from 'react'
import {
  List,
  Datagrid,
  TextField,
  NumberField,
  useRefresh,
  useUpdate,
  Filter,
  SearchInput,
  DateField,
  Create,
  Edit,
  SimpleForm,
  required,
  SelectInput,
  BooleanField,
  ReferenceInput,
  AutocompleteInput,
  TextInput,
  FormDataConsumer,
  useRedirect,
  useTranslate,
  useNotify,
  Link,
  useCreate,
  useRecordContext,
} from 'react-admin'
import { makeStyles } from '@material-ui/core/styles'
import {
  Button as ButtonM,
  Divider,
  Tabs,
  Tab,
  Dialog,
  Typography,
  Grid,
  Badge,
} from '@material-ui/core'
import { ExtraPagination, ImageInputCustom } from './utils'
import UpsertFileButton, {
  PreviewButton,
  UpsertFileDialog,
} from './components/file_upload'
import FileWithContext from './models/file_with_context'
import { TranslateWrapperTextField } from './components/translatable_field_wrapper'
import { useNavigate } from 'react-router'
import Text_field_with_tooltip from './components/text_field_with_tooltip'
import Api from './Apis/api.service'
import config from './config'

const useStyles = makeStyles({
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  customDatagridHeaderCell: {
    padding: '8px',
  },
  customDatagridRowCell: {
    padding: '8px',
  },
  autocompleteModal: {
    zIndex: 9999,
  },
})

const ApproveComptableButton = ({ disabled }) => {
  const record = useRecordContext()
  if (!record) return null
  const refresh = useRefresh()
  const [approve, { loading }] = useUpdate(
    'invoices1',
    {
      id: record.id,
      data: { ...record, path: 'approve_comptable' },
      previousData: record,
    },
    {
      onSuccess: () => {
        refresh()
      },
    }
  )

  if (record.approved_comptable_user_id !== null)
    return <Typography>{record.accountant_user}</Typography>

  return (
    <ButtonM
      variant="contained"
      color="primary"
      label="Approbation comptable"
      onClick={() => {
        approve()
      }}
      disabled={loading || disabled}
      size="small"
      disableElevation
      style={{
        minHeight: '80px',
      }}
    >
      Approbation comptable
    </ButtonM>
  )
}

const ApproveCoproManagerButton = ({ disabled }) => {
  const record = useRecordContext()
  if (!record) return null
  const refresh = useRefresh()
  const [approve, { loading }] = useUpdate(
    'invoices1',
    {
      id: record.id,
      data: { ...record, path: 'approve_copromanager' },
      previousData: record,
    },
    {
      onSuccess: () => {
        refresh()
      },
    }
  )

  if (record.approved_copro_manager_user_id !== null)
    return <Typography>{record.other_user}</Typography>
  return (
    <ButtonM
      variant="contained"
      color="primary"
      label="Approbation gestionnaire"
      onClick={() => {
        approve()
      }}
      disabled={loading || disabled}
      size="small"
      disableElevation
      style={{
        minHeight: '80px',
      }}
    >
      Approbation gestionnaire
    </ButtonM>
  )
}

const ApproveProcessOwnerButton = ({ disabled }) => {
  const record = useRecordContext()
  const refresh = useRefresh()

  if (!record) return null
  const [approve, { loading }] = useUpdate(
    'invoices1',
    {
      id: record.id,
      data: { ...record, path: 'approve_processowner' },
      previousData: record,
    },
    {
      onSuccess: () => {
        refresh()
      },
    }
  )

  if (record.approved_process_owner_user_id !== null)
    return <Typography>{record.other_user}</Typography>

  return (
    <ButtonM
      variant="contained"
      color="primary"
      label="Approbation process owner"
      onClick={() => {
        approve()
      }}
      disabled={loading || disabled}
      size="small"
      disableElevation
      style={{
        minHeight: '80px',
      }}
    >
      Approbation process owner
    </ButtonM>
  )
}

const ApproveCSStatus = () => {
  const record = useRecordContext()
  if (record && record.approved_cs_coproprietaire_id !== null)
    return <Typography>{record.other_user}</Typography>

  return <div>Non</div>
}

const CoproFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
  </Filter>
)

const TabsComponent = (props) => {
  const navigate = useNavigate()
  const { id } = props
  const tabs_items = [
    { id: 'Factures à approuver', name: 'Factures à approuver', route: '1' },
    { id: 'Factures approuvées', name: 'Factures approuvées', route: '2' },
    { id: 'Comptabilisé', name: 'Comptabilisé', route: '3' },
  ]
  const [tab, setTab] = useState(tabs_items[props.idx].id)
  const handleChange = (event, value) => {
    var idx = tabs_items.findIndex((obj) => obj.id === value)
    var nb = tabs_items[idx]['route']
    navigate(`/invoices${nb}`)
  }
  return (
    <div>
      <Tabs
        variant="fullWidth"
        centered
        value={tab}
        indicatorColor="primary"
        onChange={handleChange}
      >
        {tabs_items.map((choice) => (
          <Tab key={choice.id} label={choice.name} value={choice.id} />
        ))}
      </Tabs>
      <Divider />
    </div>
  )
}

export const InvoicesCreate1 = (props) => {
  const translate = useTranslate()
  const redirect = useRedirect()
  const notify = useNotify()
  const [invoiceFileData, setInvoiceFileData] = useState()
  const [coproInternalId, setCoproInternalId] = useState()
  const successHandler = (data) => {
    const { id, invoice_id, copro_id } = data
    const request = new Request(
      `${config.API_V1}/file_with_context/${invoice_id}`,
      {
        method: 'PUT',
        headers: new Headers({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({
          linkable_id: id,
          linkable_type: 'invoices1',
        }),
      }
    )
    fetch(request).then(() => {
      redirect('list', 'invoices1')
    })
  }
  const [create] = useCreate()
  const save = useCallback(
    async (values) => {
      if (!invoiceFileData.invoice_id || !coproInternalId) {
        notify('hs.file.errors.invoice_creation', 'error')

        return { invoice_id: translate('hs.file.errors.invoice_creation') }
      }
      try {
        create(
          'invoices1',
          { data: { ...values, ...invoiceFileData } },
          { onSuccess: successHandler }
        )
      } catch (error) {
        if (error.body.errors) {
          return error.body.errors
        }
      }
    },
    [create]
  )

  return (
    <Create {...props}>
      <SimpleForm onSubmit={save}>
        <ReferenceInput
          fullWidth
          label="Code Copro"
          source="copro_id"
          reference="copros_monday"
          validate={[required()]}
        >
          <AutocompleteInput
            fullWidth
            optionText="code"
            matchSuggestion={() => true}
            onChange={(e) => {
              Api.copros.getByMondayId(e).then((value) => {
                console.log('change', value.data.copro_internal_id)
                setCoproInternalId(value.data.copro_internal_id)
              })
            }}
          />
        </ReferenceInput>
        <ReferenceInput
          label="Prestataire"
          source="provider"
          reference="prestas"
          fullWidth
          sort={{ field: 'name', order: 'ASC' }}
        >
          <AutocompleteInput
            fullWidth
            optionText="name"
            matchSuggestion={() => true}
          />
        </ReferenceInput>

        <ImageInputCustom
          fullWidth
          labelMultiple="Déposez les fichiers ou cliquez ici pour en sélectionner."
          from="invoices"
          source="process5_rib"
          label="RIB"
          deletable={false}
        />
        <TextInput
          fullWidth
          source="process5_rib__texte_"
          label="RIB (texte)"
        />
        <FormDataConsumer>
          {({ formData, ...rest }) => (
            <UpsertFileButton
              resource="file_with_context"
              documentType={FileWithContext.DOCUMENT_TYPE.COPRO}
              issuedBy={FileWithContext.ISSUED_BY.HELLO_APP}
              limitQuantity={1}
              copro_id={coproInternalId}
              validTypes={[FileWithContext.TYPE.INVOICE]}
              validCategories={[FileWithContext.CATEGORY.ACCOUNTING]}
              saveResult={(result) => {
                const [
                  {
                    id,
                    amount_excl_vat,
                    amount_incl_vat,
                    purpose,
                    url,
                    issue_date,
                  },
                ] = result.accepted_files
                setInvoiceFileData({
                  invoice_id: id,
                  process5_montant_ht: amount_excl_vat,
                  process5_montant_ttc: amount_incl_vat,
                  process5_libelle: purpose,
                  process5_facture: url,
                  issue_date: issue_date,
                })
              }}
              show_shared_select={true}
            />
          )}
        </FormDataConsumer>
      </SimpleForm>
    </Create>
  )
}

export const InvoicesEdit1 = (props) => {
  const translate = useTranslate()
  const notify = useNotify()
  const [invoiceFileData, setInvoiceFileData] = useState()
  const [update] = useUpdate()
  const save = useCallback(
    async (values) => {
      try {
        update('invoices1', {
          id: values.id,
          data: { ...values, ...invoiceFileData },
        })
      } catch (error) {
        if (error.body && error.body.errors) {
          return error.body.errors
        } else {
          console.error(error)
        }
      }
    },
    [update]
  )

  return (
    <Edit {...props}>
      <SimpleForm onSubmit={save}>
        <ReferenceInput
          fullWidth
          label="Code Copro"
          source="copro_id"
          reference="copros_monday"
          validate={[required()]}
        >
          <AutocompleteInput fullWidth optionText="code" />
        </ReferenceInput>
        <ReferenceInput
          label="Prestataire"
          source="process5_prestataire"
          reference="prestas"
          fullWidth
        >
          <AutocompleteInput fullWidth optionText="name" />
        </ReferenceInput>
        <ImageInputCustom
          fullWidth
          labelMultiple="Déposez les fichiers ou cliquez ici pour en sélectionner."
          from="invoices"
          source="process5_rib"
          label="RIB"
          deletable={false}
        />
        <TextInput
          fullWidth
          source="process5_rib__texte_"
          label="RIB (texte)"
        />
        <FormDataConsumer>
          {({ formData, ...rest }) => (
            <UpsertFileButton
              resource="file_with_context"
              documentType={FileWithContext.DOCUMENT_TYPE.COPRO}
              issuedBy={FileWithContext.ISSUED_BY.HELLO_APP}
              limitQuantity={1}
              validTypes={[FileWithContext.TYPE.INVOICE]}
              validCategories={[FileWithContext.CATEGORY.ACCOUNTING]}
              defaultValue={[formData.fwc]}
              saveResult={(result) => {
                const [
                  {
                    id,
                    amount_excl_vat,
                    amount_incl_vat,
                    purpose,
                    url,
                    issue_date,
                  },
                ] = result.accepted_files
                setInvoiceFileData({
                  invoice_internal_id: id,
                  process5_montant_ht: amount_excl_vat,
                  process5_montant_ttc: amount_incl_vat,
                  process5_libelle: purpose,
                  process5_facture: url,
                  issue_date: issue_date,
                })
              }}
              show_shared_select={true}
            />
          )}
        </FormDataConsumer>
      </SimpleForm>
    </Edit>
  )
}

const LinkToTicketList = () => {
  const record = useRecordContext()
  if (!record) return null

  return (
    <Link
      to={{
        pathname: '/tickets',
        search: `filter=${JSON.stringify({ linkable_id: record.ticket_id })}`,
      }}
    >
      {record.ticket_id}
    </Link>
  )
}

export const InvoicesList1 = (props) => {
  const classes = useStyles()

  return (
    <div>
      <TabsComponent idx={0} {...props} />
      <List
        {...props}
        exporter={false}
        pagination={<ExtraPagination />}
        perPage={50}
        filters={<CoproFilter />}
      >
        <Datagrid
          classes={{
            headerCell: classes.customDatagridHeaderCell,
            rowCell: classes.customDatagridRowCell,
          }}
          bulkActionButtons={false}
          rowClick="edit"
        >
          <NumberField source="id" label="Id" />
          <TextField source="copromatic_id" label="Id copromatic" />
          <TranslateWrapperTextField source="invoice_type" prefix={'hs.file'}>
            <TextField />
          </TranslateWrapperTextField>
          <LinkToTicketList source="ticket_id" label="Ticket" />
          <TextField source="code" label="Copro" />
          <TextField source="process5_libelle" label="Libelle" />
          <NumberField source="process5_montant_ht" label="HT" />
          <NumberField source="process5_montant_ttc" label="TTC" />
          <PreviewButton source="process5_facture" label="Facture" />
          <DateField source="created" label="Créé le" />
          <ApproveComptableButton />
          <ApproveCoproManagerButton />
          <ApproveProcessOwnerButton />
          <ApproveCSStatus label="Approb. CS" />
        </Datagrid>
      </List>
    </div>
  )
}

//record = invoice
const SendCopromatic = (props) => {
  const record = useRecordContext()
  const classes = useStyles()
  const [showDialog, setShowDialog] = useState(false)
  const toggleDialog = () => setShowDialog(!showDialog)

  const [create] = useCreate()
  const save = useCallback(
    async (values) => {
      try {
        create('invoices2', { data: { ...values, record } })
      } catch (error) {
        if (error.body.errors) {
          return error.body.errors
        }
      }
    },
    [create]
  )

  if (record.sent_to_copromatic === true) return null

  const handleClick = () => {
    toggleDialog()
  }

  return (
    <div>
      <Dialog open={showDialog} onClose={toggleDialog}>
        <div style={{ padding: '20px' }}>
          <Create basePath="/" title=" " resource="invoices2">
            <SimpleForm
              redirect={false}
              variant="outlined"
              handleClose={toggleDialog}
              onSubmit={save}
            >
              <ReferenceInput
                source="presta_id"
                reference="invoices2/copromatic_providers"
                validate={[required()]}
                filter={{
                  copromatic_copro_id: record.copromatic_copro_id,
                }}
              >
                <AutocompleteInput
                  optionValue="id"
                  optionText="libelle"
                  options={{
                    suggestionsContainerProps: {
                      className: classes.autocompleteModal,
                    },
                  }}
                />
              </ReferenceInput>
              <ReferenceInput
                source="repartition_id"
                reference="invoices2/repartitions"
                validate={[required()]}
                filter={{
                  copromatic_copro_id: record.copromatic_copro_id,
                }}
              >
                <AutocompleteInput
                  optionValue="id"
                  optionText="libelle"
                  options={{
                    suggestionsContainerProps: {
                      className: classes.autocompleteModal,
                    },
                  }}
                />
              </ReferenceInput>
              <ReferenceInput
                source="compte_id"
                reference={`invoices2/accounts`}
                validate={[required()]}
                filter={{
                  copromatic_copro_id: record.copromatic_copro_id,
                }}
              >
                <SelectInput optionValue="id" optionText="libelle" />
              </ReferenceInput>
              <ReferenceInput
                source="exercice_id"
                reference="invoices2/exercises"
                validate={[required()]}
                filter={{
                  copromatic_copro_id: record.copromatic_copro_id,
                }}
              >
                <AutocompleteInput
                  optionValue="id"
                  optionText="libelle"
                  options={{
                    suggestionsContainerProps: {
                      className: classes.autocompleteModal,
                    },
                  }}
                />
              </ReferenceInput>
            </SimpleForm>
          </Create>
        </div>
      </Dialog>
      <ButtonM
        variant="contained"
        color="primary"
        label="Envoi copromatic"
        onClick={handleClick}
      >
        Envoi copromatic
      </ButtonM>
    </div>
  )
}

const ApprovedRenderer = ({ text_source, date_source }) => {
  const record = useRecordContext()
  if (!record) return null
  return (
    <Grid container>
      <Grid item>
        <Text_field_with_tooltip source={text_source} maxLength={10} />
      </Grid>
      {record[date_source] && (
        <Grid item>
          <Badge
            style={{
              backgroundColor: '#FCCC60',
              borderRadius: '1rem',
              padding: '2px 8px',
            }}
          >
            <DateField source={date_source} />
          </Badge>
        </Grid>
      )}
    </Grid>
  )
}

export const InvoicesList2 = (props) => {
  const classes = useStyles()

  return (
    <div>
      <TabsComponent idx={1} {...props} />
      <List
        {...props}
        exporter={false}
        pagination={<ExtraPagination />}
        perPage={50}
        filters={<CoproFilter />}
      >
        <Datagrid
          classes={{
            headerCell: classes.customDatagridHeaderCell,
            rowCell: classes.customDatagridRowCell,
          }}
          bulkActionButtons={false}
        >
          <NumberField source="id" label="Id" />
          <LinkToTicketList source="ticket_id" label="Ticket" />
          <TextField source="code" label="Copro" />
          <TextField source="process5_libelle" label="Libelle" />
          <NumberField source="process5_montant_ht" label="HT" />
          <NumberField source="process5_montant_ttc" label="TTC" />
          <PreviewButton source="process5_facture" label="Facture" />
          <ApprovedRenderer
            date_source="approved_cs_coproprietaire_ts"
            text_source="approved_by_cs"
            source="approved_by_cs"
          />
          <ApprovedRenderer
            date_source="approved_comptable_ts"
            text_source="approved_by_comptable_user"
            source="approved_by_comptable_user"
          />
          <ApprovedRenderer
            date_source="approved_copro_manager_ts"
            text_source="approved_by_copro_manager"
            source="approved_by_copro_manager"
          />
          <ApprovedRenderer
            date_source="approved_process_owner_ts"
            text_source="approved_by_process_owner"
            source="approved_by_process_owner"
          />
          <DateField source="created" label="Créé le" />
          <BooleanField
            source="sent_to_copromatic"
            label="Envoyé à Copromatic"
          />
          <SendCopromatic />
        </Datagrid>
      </List>
    </div>
  )
}

export const InvoicesList3 = (props) => {
  const classes = useStyles()

  return (
    <div>
      <TabsComponent idx={2} {...props} />
      <List
        {...props}
        exporter={false}
        pagination={<ExtraPagination />}
        perPage={50}
        filters={<CoproFilter />}
      >
        <Datagrid
          classes={{
            headerCell: classes.customDatagridHeaderCell,
            rowCell: classes.customDatagridRowCell,
          }}
          bulkActionButtons={false}
        >
          <NumberField source="id" label="Id" />
          <LinkToTicketList source="ticket_id" label="Ticket" />
          <TextField source="code" label="Copro" />
          <TextField source="process5_libelle" label="Libelle" />
          <NumberField source="process5_montant_ht" label="HT" />
          <NumberField source="process5_montant_ttc" label="TTC" />
          <PreviewButton source="process5_facture" label="Facture" />
          <ApprovedRenderer
            date_source="approved_cs_coproprietaire_ts"
            text_source="approved_by_cs"
            source="approved_by_cs"
          />
          <ApprovedRenderer
            date_source="approved_comptable_ts"
            text_source="approved_by_comptable_user"
            source="approved_by_comptable_user"
          />
          <ApprovedRenderer
            date_source="approved_copro_manager_ts"
            text_source="approved_by_copro_manager"
            source="approved_by_copro_manager"
          />
          <ApprovedRenderer
            date_source="approved_process_owner_ts"
            text_source="approved_by_process_owner"
            source="approved_by_process_owner"
          />
          <DateField source="created" label="Créé le" />
        </Datagrid>
      </List>
    </div>
  )
}
